/* global axios */
import ApiClient from './ApiClient';

class FunnelAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  async create(data) {
    return axios.post(this.url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  async update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async reorderStages(id, stages) {
    return axios.patch(
      `${this.url}/${id}/reorder`,
      { stages },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  async getStageStats(funnelId, filterParams = {}) {
    return axios.get(`${this.url}/${funnelId}/stage_stats`, {
      params: filterParams,
    });
  }

  // Contagens do modal "Excluir funil" (abertas, origem protegida, destino).
  async archivePreview(id) {
    return axios.get(`${this.url}/${id}/archive_preview`);
  }

  async getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  async getAll() {
    return axios.get(this.url);
  }
}

export default new FunnelAPI();
